/**
 * Формат URL реферальной вакансии на сайте: /referral-jobs/:slug-:id
 */

const CYRILLIC_TO_LATIN: Record<string, string> = {
  а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z',
  и: 'i', й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r',
  с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'sch',
  ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
};

function transliterate(text: string): string {
  return text
    .toLowerCase()
    .split('')
    .map((char) => CYRILLIC_TO_LATIN[char] ?? (char.match(/[a-z0-9]/i) ? char : ' '))
    .join('');
}

function slugify(title: string): string {
  if (!title || typeof title !== 'string') return '';
  const t = transliterate(title.trim());
  return t
    .replace(/\s+/g, '_')
    .replace(/[^a-z0-9_]/gi, '')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 80);
}

/** URL страницы реферальной вакансии на публичном сайте */
export function getReferralJobPublicUrl(id: number, title: string, origin?: string): string {
  const base = origin || (typeof window !== 'undefined' ? window.location.origin : 'https://rabotamax.ru');
  const slug = slugify(title);
  const path = slug ? `/referral-jobs/${slug}-${id}` : `/referral-jobs/${id}`;
  return base.replace(/\/$/, '') + path;
}
